import * as Redux from "redux";
import {configActions} from "../features/config/configSlice";
import {viewActions} from "../features/view/viewSlice";
import {EditorTool} from "../models/enums";

export const autoEnableAngleSnappingOnScaleTool: Redux.Middleware = (store) => (next) => (action) => {
    if (action.type === configActions.switchEditorTool.type) {
        const newTool = action.payload.editorTool;
        if (newTool === EditorTool.SCALE) {
            store.dispatch(viewActions.setAngleSnapping(true));
        }
    }

    next(action);
}
